import { render, staticRenderFns } from "./ModalWrapperComponent.vue?vue&type=template&id=efa0fb98&scoped=true&"
import script from "./ModalWrapperComponent.vue?vue&type=script&lang=ts&"
export * from "./ModalWrapperComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa0fb98",
  null
  
)

export default component.exports